<template>
  <vue-element-loading v-if="active" :active="active" :spinner="spinner" :color="getPrimaryColour()" :backgroundColor="backgroundColor" :size="size" duration="1.5" :is-full-screen="fullScreen" :text="text"/>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { getPrimaryColour } from '@/constants/colours'

const VELMLD_PARENT_CLASS = 'velmld-parent'

export default {
  name: 'loading-anim',
  components: {
    VueElementLoading
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: '110'
    },
    spinner: {
      type: String,
      required: false,
      default: 'ring'
    },
    fullScreen: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: String,
      required: false
    },
		toggleParentClass: {
			type: Boolean,
			required: false,
			default: false
		},
		backgroundColor: {
			type: String,
			required: false,
			default: 'rgba(255, 255, 255, 0.85)'
		}
  },
  data () {
    return {
      getPrimaryColour
    }
  },
	watch: {
		active: function (val) {
			if (this.toggleParentClass && !val) {
				const parent = document.querySelector(`.${VELMLD_PARENT_CLASS}`)
				parent.classList.remove(VELMLD_PARENT_CLASS)
			}
		}
	}
  /* mounted () {
    document.querySelector('.velmld-parent').style.backgroundColor = 'rgba(255, 255, 255, 0.5)'
  } */
}
</script>

<style lang="scss">
  .velmld-overlay {
    background-color: rgba(255, 255, 255, 0.3) !important;
/*     -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px); */
  }

  /* .velmld-overlay {
    background-color: transparent !important;
  } */
</style>



// WEBPACK FOOTER //
// src/components/utils/LoadingAnim.vue